<template>
  <div>
    <div>
      <plain-jersey
        v-if="type === 'plain'"
        :primary-color="primaryColor"
        :secondary-color="secondaryColor"
      />
      <vertical-stripes-jersey
        v-else-if="type === 'vertical-stripes'"
        :primary-color="primaryColor"
        :secondary-color="secondaryColor"
      />
      <horizontal-stripes-jersey
        v-else-if="type === 'horizontal-stripes'"
        :primary-color="primaryColor"
        :secondary-color="secondaryColor"
      />
    </div>
  </div>
</template>

<script>
import HorizontalStripesJersey from './HorizontalStripesJersey'
import PlainJersey from './PlainJersey'
import VerticalStripesJersey from './VerticalStripesJersey'
export default {
  name: 'JerseyIcon',
  components: {
    PlainJersey,
    HorizontalStripesJersey,
    VerticalStripesJersey,
  },
  props: {
    primaryColor: {
      type: String,
      required: false,
      default: '#00A82D',
    },
    secondaryColor: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
    type: {
      type: String,
      required: false,
      default: 'plain',
      validator(val) {
        return ['plain', 'vertical-stripes', 'horizontal-stripes'].includes(val)
      },
    },
  },
}
</script>
